import React, { useState, useEffect } from 'react';
import notification from '../../../elements/lib/NotificationWrapper';

import { Translation, getI18n } from 'react-i18next';
import { Modal, Typography, Button, List, Checkbox } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

const { Title, Text } = Typography;

const LearningAdminModuleCategoryModal = ({
  setVisible,
  visible,
  localOptions,
  setLocalOptions,
  selected,
  setSelected,
  handleSave,
  remove,
  partnershipId,
  load,
  ...props
}) => {
  const [newSelected, setNewSelected] = useState([]);

  const toggleCheck = (id) => {
    setNewSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const onClickSave = () => {
    setSelected(newSelected);
    handleSave(newSelected);
    setVisible(false);
  };

  useEffect(() => {
    setNewSelected(selected);
  }, [selected]);

  const handleDelete = (id) => {
    remove(partnershipId, id, (success) => {
      if (success) {
        const updatedSelected = newSelected.filter((x) => x !== id);
        const updatedOptions = localOptions.filter((x) => x.id !== id);
        setNewSelected(updatedSelected);
        setLocalOptions(updatedOptions);
        handleSave(updatedSelected);

        notification.success(getI18n().t('feedback_delete_success'));
      } else {
        notification.error(getI18n().t('feedback_delete_error'));
      }
    });
  };

  return (
    <Translation>
      {(t) => (
        <>
          <Modal
            title={
              <Title level={4} className='module-category-title'>
                {t('learning_admin_form_module_category_modal_title')}
              </Title>
            }
            closable={false}
            className='module-category-modal'
            centered
            onCancel={() => setVisible(false)}
            visible={visible}
            footer={[
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <Button
                  block
                  size={'large'}
                  key='back'
                  style={{ marginRight: '8px', flex: 1 }}
                  onClick={() => setVisible(false)}
                >
                  {t('learning_admin_form_module_category_modal_btn_cancel')}
                </Button>

                <Button
                  block
                  size={'large'}
                  key='submit'
                  type='primary'
                  onClick={onClickSave}
                  style={{ marginLeft: '8px', flex: 1 }}
                >
                  {t('learning_admin_form_module_category_modal_btn_save')}
                </Button>
              </div>,
            ]}
          >
            <Title level={5} style={{ marginLeft: '16px' }}>
              {t('learning_admin_form_module_category_modal_subtitle')}
            </Title>
            <List
              className='module-categories'
              dataSource={localOptions}
              renderItem={({ id, name }) => (
                <List.Item
                  key={id}
                  style={{ padding: '4px 16px' }}
                  actions={[
                    <FontAwesomeIcon
                      style={{
                        cursor: 'pointer',
                        marginTop: '6px',
                      }}
                      onClick={() => handleDelete(id)}
                      icon={faTrashCan}
                      className='module-action-icon-delete'
                    />,
                  ]}
                >
                  <Checkbox
                    checked={newSelected.includes(id)}
                    onChange={() => toggleCheck(id)}
                  >
                    <Text style={{ fontSize: 16 }} strong>
                      {name}
                    </Text>
                  </Checkbox>
                </List.Item>
              )}
            />
          </Modal>
        </>
      )}
    </Translation>
  );
};

export default LearningAdminModuleCategoryModal;
